export default "__VITE_ASSET__C9vAK3sF__"